<template>
  <div>
    <pallet-rack-configurator />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

// @ is an alias to /src
import PalletRackConfigurator from "@/components/PalletRackConfigurator.vue";

export default {
  name: "Home",
  components: {
    PalletRackConfigurator
  },
data: () => ({
    // TODO Remove this possibly
    currentUser: null
  }),

  // TODO evaluate if these getters are used
  computed: {
    ...mapGetters({
      isLoggedIn: "getUserStatus",
      user: "getUser"
    }),
    username() {
      return this.user ? this.user.username : ", there!";
    }
  },

  methods: {
    ...mapActions({
      updateUser: "updateUser"
    })
  }
};
</script>
